<plyca-ui-filter-generic
  [config]="{
    model: model,
    hasHeader: true,
    formConfigFilters: formConfigFilters,
    jsonFile: 'catalogProject/catalogProjectFilterCartSettings.json'
  }"
  (valuesFormChange)="valuesOnChange($event)"
>
</plyca-ui-filter-generic>
